/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PreviewImageSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  XLarge = 'XLarge'
}
